<template>
  <v-dialog
    v-model="help"
    width="500"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        color="primary"
        v-on="on"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title primary-title>
        Suchhilfe
      </v-card-title>

      <v-card-text>
        <p>
          Eine Suche ist über die Eingabe in den Suchschlitz oder über die Suchmaske (öffnet sich durch Klick auf
          „Hamburger“-Icon links neben dem Suchschlitz) möglich.
        </p>

        <p>
          Auswahl und Eingaben in der Suchmaske werden automatisch auch im Suchschlitz dargestellt und können dort
          geändert werden.
        </p>

        <p>
          Eine Suche nach zwei oder mehr Begriffen, die unverbunden eingegeben werden, bringt als Ergebnis alle
          Texte, in denen <span class="font-weight-black">alle</span> gesuchten Begriffe vorkommen.
        </p>

        <p>
          <span class="font-weight-black">Eingrenzung der Ergebnisse:</span>
        </p>

        <p>
          Suche z.B. nach <span class="font-italic">EKD-Ratsvorsitzender AND NOT Bedford-Strohm</span> zeigt alle
          Texte, in denen <span class="font-italic">EKD-Ratsvorsitzender</span>, <span class="font-weight-black">
          aber nicht</span> <span class="font-italic">Bedford-Strohm</span> steht.
        </p>

        <p>
          Suche z.B. nach <span class="font-italic">Bedford-Strohm OR "Nikolaus Schneider"</span> zeigt alle Texte,
          in denen entweder <span class="font-italic">Heinrich Bedford-Strohm</span> <span class="font-weight-black">
          oder</span> <span class="font-italic">Nikolaus Schneider</span> vorkommt.
        </p>

        <p>
          Phrasensuche: Phrase in An- und Abführungszeichen setzen (z. B. <span class="font-italic">„sagte der
          EKD-Ratsvorsitzende Bedford-Strohm“</span>)
        </p>

        <p>
          Suche nach Texten über einen bestimmten Zeitraum - Eingabe über die Suchmaske oder in den Suchschlitz
          im Format: von:dd.mm.yyyy bis:dd.mm.yyyy
        </p>

        <p>
          In der Suchmaske lässt sich einstellen, ob auch pdf-Dokumente (wie z.B. die werktägliche Zentralausgabe
          des epd-Basisdienstes) durchsucht werden sollen.
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="help = false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    help: false,
  }),
};
</script>
